import { Button, Badge } from '@e2n/ui';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/LehrjahrFilter';
import { StatusFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StatusFilter';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { StandorteFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StandorteFilter.tsx';
import { SortierungButton } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SortierungButton.tsx';

export function Header() {
  const [showUebersichtFilterOptions, setShowUebersichtFilterOptions] =
    useState(false);
  const { store } = useRotationsplanFeatureContext();
  const { view } = useParams();
  const { t } = useTranslation();

  const {
    ui: {
      uebersicht: { filter },
    },
  } = store;

  let selectedFilterCount = 0;
  Object.values(filter).forEach((filter) => {
    if (filter.length > 0) {
      selectedFilterCount += 1;
    }
  });

  return (
    <>
      <div className="flex gap-1 items-center">
        <Button
          className="flex items-center gap-2"
          variant="ghost"
          onClick={() => setShowUebersichtFilterOptions((prev) => !prev)}>
          <FontAwesomeIcon icon={faFilter} />
          {t('domain.mitarbeiter.rotationsplan.filter.label')}
          <Badge type="pill" variant="secondary">
            {selectedFilterCount}
          </Badge>
        </Button>
        <SortierungButton view={view as View} />
      </div>
      {showUebersichtFilterOptions && (
        <div className="w-full overflow-auto">
          <div className="flex items-center gap-2">
            <BerufeFilter view={view as View} />
            <LehrjahrFilter view={view as View} />
            <StatusFilter />
            <StandorteFilter view={view as View} />
          </div>
        </div>
      )}
    </>
  );
}
